import axios from 'axios'

const origin = process.env.VUE_APP_API_ORIGIN
const responseData = response => response.data

export default {
  get (year) {
    return axios.get(origin + '/setting/holiday-calendar', {
      params: { year }
    }).then(responseData)
  },
  updateNationalHoliday (payload) {
    return axios.post(origin + '/setting/holiday-calendar/national-holiday', payload).then(responseData)
  },
  updateWeekly (payload) {
    return axios.post(origin + '/setting/holiday-calendar/weekly', payload).then(responseData)
  },
  saveHoliday (payload) {
    return axios.post(origin + '/setting/holiday-calendar/holidays/save', payload).then(responseData)
  },
  deleteHoliday (payload) {
    return axios.post(origin + '/setting/holiday-calendar/holidays/delete', payload).then(responseData)
  }
}
